module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/47MtZW/tc-custom/9781504094092.jpg?1716663164701",
      "alt": "This image is the cover for the book Fallible Justice, Wilde Investigations"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fallible Justice, Wilde Investigations\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("First in the compelling paranormal mystery series: When those who pronounce judgment are omniscient, can a verdict ever be overturned?")]), _c('br'), _c('br'), _vm._v(" In Old London, where paranormal races co-exist with ordinary humans, criminal verdicts delivered by the all-seeing Heralds of Justice are faultless. After a man is declared guilty of murder and sentenced to death, his daughter turns to private investigator Yannia Wilde to do the impossible and prove the Heralds wrong."), _c('br'), _c('br'), _vm._v(" Yannia escaped a restrictive life in the Wild Folk conclave where she was raised, but her background marks her as an outsider in the city. Her origins lend her the sensory abilities of all of nature, yet Yannia is lonely and struggling to adapt to life in the city. The case could be the break she needs."), _c('br'), _c('br'), _vm._v(" She enlists the help of her only friend, a Bird Shaman named Karrion, and together they accept the challenge of proving a guilty man innocent. So begins a breathless race against time against all conceivable odds. Can Yannia and Karrion save a man who has been infallibly judged guilty?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Laura Laakso\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0